import { AxiosError } from 'axios';
import LayoutContext from 'components/Layout/LayoutContext';
import FloatingPanel from 'components/__SHARED__/floatingPanel/floatingPanel';
import { useClientPaginator } from 'hooks/useClientPaginator';
import { AssessorRoutePath } from 'library/Routes';
import translation from 'locales/translation';
import {
  CircleArrowRight,
  Col,
  IconButton,
  Notification,
  NotificationType,
  Pagination,
  Row,
  ScreenSize,
  ToastTypes,
  useScreenSize,
} from 'plataforma-fundacao-componentes';
import { Fragment, useContext, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Link, useLocation } from 'react-router-dom';
import { useGetNotifications } from 'services/notification';
import { IReducer } from 'store/Reducer';
import BellIcon from './bellIcon';

import styles from './central-notificacao.module.scss';

export default function CentralNotificacao() {
  const [page, setPage] = useState<number>(1);
  const [opened, setOpened] = useState(false);
  const [ref, setRef] = useState<HTMLDivElement | null>(null);
  const { showToast } = useContext(LayoutContext);

  const size = 3;

  const location = useLocation();
  const { usuario } = useSelector((state: IReducer) => state.auth);
  const { rankedSize } = useScreenSize();

  const { data, isLoading, error, isError, refetch } = useGetNotifications();

  // Only development

  const paginator = useClientPaginator(data! ?? [], page, size);

  useEffect(() => {
    if (isError) {
      showToast({
        pauseOnFocusLoss: true,
        theme: ToastTypes.Error,
        showStatusBar: true,
        timeout: 4000,
        label:
          translation.Toasts.Errors.Keys[
            `${
              (error as AxiosError<Error>).response?.data.message ||
              (error as AxiosError<Error>).response?.data ||
              (error as AxiosError<Error>).message
            }` as keyof typeof translation.Toasts.Errors.Keys
          ] ?? translation.Toasts.Errors.defaultAlternative,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isError]);

  useEffect(() => {
    if (
      [AssessorRoutePath, `${AssessorRoutePath}/`].includes(location.pathname)
    ) {
      refetch();
    }
  }, [location.pathname, refetch]);

  if (
    !usuario?.perfil.assessorRoute.notificacoes.ver ||
    ![AssessorRoutePath, `${AssessorRoutePath}/`].includes(location.pathname)
  ) {
    return <Fragment />;
  }

  return (
    <Fragment>
      <div
        ref={(r) => setRef(r)}
        style={{
          position: 'relative',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          marginTop: '-2px',
        }}
      >
        <IconButton
          disabled={!data?.length!}
          style={{ userSelect: 'none' }}
          icon={
            <Notification
              count={data?.length}
              type={NotificationType.Error}
              verticalOuter={6}
              horizontalOuter={6}
            >
              <BellIcon />
            </Notification>
          }
          onClick={() => {
            setOpened(!opened);
          }}
        />
      </div>
      <FloatingPanel
        statedAnchorRef={ref}
        opened={opened}
        setOpened={setOpened}
        style={
          rankedSize <= ScreenSize.sm
            ? { marginLeft: '0' }
            : { marginLeft: '-38px' }
        }
        offset={rankedSize <= ScreenSize.sm ? 22 : 11}
      >
        <Row className={styles['central-notificacao']}>
          <Row>
            <Col className={styles.header}>
              <BellIcon />
              <p>Mensagens ({data?.length})</p>
            </Col>
            <Col className={styles.body} noPadding>
              <Row>
                {paginator.map((item: any) => {
                  return (
                    <Link
                      className={styles.items}
                      to={`${AssessorRoutePath}/evento/${item.id}/mensagens`}
                      target={'_blank'}
                      onClick={() => setOpened(false)}
                    >
                      <Row>
                        <Col cols={[10, 10, 10, 10, 10]}>
                          <Row>
                            <Col className={styles.title} noPadding>
                              <div />
                              <span>
                                {item.title} - {item.id}
                              </span>
                            </Col>
                            <Col
                              className={styles.body}
                              noPadding
                              style={{ marginTop: '4px' }}
                            >
                              <p>
                                Há mensagens pendentes no evento <br />”
                                {item.title ?? ''}”
                              </p>
                            </Col>
                          </Row>
                        </Col>
                        <Col
                          cols={[2, 2, 2, 2, 2]}
                          centralized
                          style={{ color: '#3fa110' }}
                        >
                          <CircleArrowRight />
                        </Col>
                      </Row>
                    </Link>
                  );
                })}
              </Row>
            </Col>
            {data?.length! > 3 ? (
              <Col className={styles.footer}>
                <Pagination
                  totalPages={data?.length ?? 1}
                  currentPage={page}
                  loading={isLoading}
                  boundaryCount={1}
                  siblingCount={0}
                  onPageChange={(_, val) => {
                    setPage(val);
                  }}
                  countPages={{
                    rows: size,
                    totalItems: data?.length!,
                  }}
                />
              </Col>
            ) : (
              <Fragment />
            )}
          </Row>
        </Row>
      </FloatingPanel>
    </Fragment>
  );
}
